export enum DatasheetType {
  FrequencyBasedDataSheet = 1,
  PartialInterval = 3,
  Latency = 2,
  ReplacementBehavior = 4,
}
